<template>
  <el-dialog
    title="Submit your answer"
    :visible="dialogVisible"
    width="80%"
    :before-close="handleClose"
  >
    <el-form :model="form" label-width="120px">
      <el-form-item label="Content: ">
        <MarkdownEdit :value="form.description" @input="updateDescription" withMaxHeight />
      </el-form-item>
      <el-form-item label="Add Attachment: ">
        <el-upload
          action
          :limit="1"
          :fileList="fileList"
          :on-change="handleFileAppend"
          :on-remove="handleFileRemove"
          :auto-upload="false"
        >
          <el-button slot="trigger" type="primary">Select File...</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hideDialog">Discard</el-button>
      <el-button type="primary" @click="handleSubmit">Submit</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MarkdownEdit from "@/atoms/MarkdownEdit.vue";
import { postAnswer } from "@/api";

export default {
  name: "AnswerSubmitForm",
  props: {
    dialogVisible: Boolean
  },
  components: {
    MarkdownEdit
  },
  data() {
    return {
      fileList: [],
      form: {
        description: ""
      }
    };
  },
  methods: {
    updateDescription(value) {
      this.form.description = value;
    },
    clearForm() {
      this.form = {
        description: ""
      };
      this.fileList = [];
    },
    hideDialog() {
      this.clearForm();
      this.$emit("update:dialogVisible", false);
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleFileAppend(file, fileList) {
      this.fileList = fileList;
    },
    handleClose() {
      this.$confirm("Discard Changes?")
        .then(() => {
          this.hideDialog();
        })
        .catch(() => {});
    },
    async handleSubmit() {
      if(this.$store.state.userPower === "C") {
        const { description } = this.form;
        let attachment = "";
        if (this.fileList.length > 0) {
          attachment = this.fileList[0].raw;
        }
        const res = await postAnswer(description, attachment, this.$store.state.userId, this.$route.params.homework_id);
        if (res && res.id) {
            this.hideDialog();
            this.$emit("refresh-answer-state");
            this.$message({
              type: "success",
              message: "Answer Submitted!"
            });
          }
      }
    }
  }
};
</script>

<style>
</style>